// Avatar — initials fallback, optional image, pebble-shape variant.

import { useMemo } from "react";
import { cn } from "@/lib/cn";
import { initials } from "@/lib/formatters";

export interface AvatarProps {
  name: string;
  src?: string;
  size?: number;
  tone?: "default" | "primary" | "secondary" | "tertiary";
  pebble?: boolean;
  className?: string;
}

export function Avatar({ name, src, size = 32, tone = "default", pebble, className }: AvatarProps) {
  const fallback = useMemo(() => initials(name) || "?", [name]);
  return (
    <span
      className={cn("lex-avatar", className)}
      data-tone={tone === "default" ? undefined : tone}
      style={{
        width: size,
        height: size,
        fontSize: Math.max(10, Math.round(size * 0.4)),
        borderRadius: pebble ? "var(--shape-pebble)" : "50%",
      }}
      aria-label={name}
      title={name}
    >
      {src ? <img src={src} alt="" /> : fallback}
    </span>
  );
}

export default Avatar;
